import React, { useEffect, useRef, useState } from 'react';
import useDimensions from 'react-cool-dimensions';
import Container, { styleMetadata } from './Container';
import { proxy, useProxy } from 'valtio';
// import { DAppProvider, useBlockNumber, useEthers } from '@usedapp/core';

const store = proxy({
  ...styleMetadata,
});


function App() {
  // const { library, active } = useEthers();
  const snap = useProxy(store);
  const canvasRef = useRef();
  const glRef = useRef();
  const attributesRef = useRef();
  const { ref, width, height } = useDimensions({});

  const _onCanvasResize = (p5) => {
    p5.resizeCanvas(width, height);
  };

  const mods = Object.keys(store.options).map((k) => {
    return {
      key: k,
      value: snap.options[k],
      set: (v) => {
        store.options[k] = v;
      },
    };
  });

  return (
    <div id="main"
      style={{
        display: 'flex',
        minHeight: "100vh"
      }}>
      <div style={{ flexGrow: 1 }}>
        <div
          ref={ref}
          style={{
            margin: '0 auto',
            // marginTop: '64px',
            width: '100vw',
            height: '100vh',
            // minHeight: '500px', minWidth: "500px",
            // minWidth: "100vw",
          }}
        >
          {width && height ? (
            <Container
              width={width}
              height={height}
              canvasRef={canvasRef}
              gl={glRef}
              attributesRef={attributesRef}
              handleResize={_onCanvasResize}
              {...snap.options}
            />
          ) : null}
        </div>

      </div>
    </div >
  );
}


export default App;
